import { expirationItems } from "@/mocks/documentos";

export default function ExpirationPanel() {
  const critical = expirationItems.filter((e) => e.priority === "crítico");
  const attention = expirationItems.filter((e) => e.priority === "atenção");
  const caution = expirationItems.filter((e) => e.priority === "cautela");

  const priorityConfig = {
    "crítico": { bg: "bg-danger-50", border: "border-danger-200", text: "text-danger-700", iconBg: "bg-danger-100", iconText: "text-danger-600" },
    "atenção": { bg: "bg-warning-50", border: "border-warning-200", text: "text-warning-700", iconBg: "bg-warning-100", iconText: "text-warning-600" },
    "cautela": { bg: "bg-caution-50", border: "border-caution-200", text: "text-caution-700", iconBg: "bg-caution-100", iconText: "text-caution-600" },
  };

  return (
    <div className="space-y-5">
      <h3 className="text-sm font-semibold text-foreground-900">Painel de Controle de Vencimentos</h3>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="bg-danger-50 rounded-xl border border-danger-200 p-4 text-center">
          <div className="text-2xl font-bold text-danger-700 font-heading">{critical.length}</div>
          <div className="text-xs text-danger-600 mt-1">Documentos vencidos</div>
        </div>
        <div className="bg-warning-50 rounded-xl border border-warning-200 p-4 text-center">
          <div className="text-2xl font-bold text-warning-700 font-heading">{attention.length}</div>
          <div className="text-xs text-warning-600 mt-1">A vencer em 30 dias</div>
        </div>
        <div className="bg-caution-50 rounded-xl border border-caution-200 p-4 text-center">
          <div className="text-2xl font-bold text-caution-700 font-heading">{caution.length}</div>
          <div className="text-xs text-caution-600 mt-1">A vencer em 60+ dias</div>
        </div>
      </div>

      <div className="space-y-2">
        {expirationItems.map((item) => {
          const p = priorityConfig[item.priority];
          const daysLabel = item.daysRemaining < 0
            ? `${Math.abs(item.daysRemaining)} dias vencido`
            : item.daysRemaining === 0
            ? "Vence hoje"
            : `${item.daysRemaining} dias restantes`;

          return (
            <div key={item.id} className={`flex items-center justify-between gap-4 p-3 rounded-lg border ${p.bg} ${p.border}`}>
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <div className={`w-8 h-8 rounded-lg ${p.iconBg} flex items-center justify-center shrink-0`}>
                  <i className={`ri-error-warning-line ${p.iconText} w-full h-full flex items-center justify-center text-sm`} />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-800 truncate">{item.title}</div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-xs text-foreground-500">{item.type}</span>
                    <span className="text-xs text-foreground-400">|</span>
                    <span className="text-xs text-foreground-500">{item.binding}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <div className="text-right">
                  <div className={`text-xs font-semibold ${item.priority === "crítico" ? "text-danger-700" : item.priority === "atenção" ? "text-warning-700" : "text-caution-700"}`}>
                    {daysLabel}
                  </div>
                  <div className="text-[10px] text-foreground-400">{item.expiryDate}</div>
                </div>
                <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full ${p.text} ${p.iconBg}`}>
                  {item.priority === "crítico" ? "Crítico" : item.priority === "atenção" ? "Atenção" : "Cautela"}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}